import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'avano-radio-checkbox-group',
  templateUrl: './avano-radio-checkbox-group.component.html',
  styleUrls: ['./avano-radio-checkbox-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvanoRadioCheckboxGroupComponent{
  @Input() required: boolean;
  @Input() alignHorizontal: boolean;
  @Input() label: string;
  @Input() tooltip: string;
}
